import {ROLES, ROLES_LABELS} from '../../../../constants/roles';

export const canBeTicked = (row, currentUserId) => Boolean(row?.isActive) && row?.id !== currentUserId;

export const otherRoles = (row) => (row?.roles ?? [])
    .filter(role => role !== ROLES.PARENT && role !== ROLES.NONE)
    .map(role => ROLES_LABELS[role] ?? role);

export const peopleWithOtherRoles = (rows) => (rows ?? [])
    .map(row => ({name: `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim(), roles: otherRoles(row)}))
    .filter(person => person.roles.length > 0);

// Children who have left are not counted: a parent of leavers has no child still at the school.
export const parentsWithAChildHere = (rows) => (rows ?? [])
    .filter(row => (row.roles ?? []).includes(ROLES.PARENT) && (row.childrenStillHere ?? '').trim() !== '')
    .map(row => ({name: `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim(), children: row.childrenStillHere}));

export const deactivationSummary = (rows) => {
    const count = rows?.length ?? 0;

    return `${count} ${count === 1 ? 'account' : 'accounts'} will be deactivated. They will lose access to Admicity.`;
};
